import type { Option } from '@byecode/ui'
import type { EMAIL_EDIT_TYPE, VariableTree2 } from '@lighthouse/shared'
import React, { createContext, useContext } from 'react'

type SendEmailContextValue = {
    upstreamOptions: VariableTree2[]
    multiNodeOptions: Option[]
    editType?: EMAIL_EDIT_TYPE
}

type SendEmailProviderProps = SendEmailContextValue & {
    children: React.ReactNode
}

const SendEmailContext = createContext<SendEmailContextValue>({
    upstreamOptions: [],
    multiNodeOptions: []
})

export const SendEmailProvider: React.FC<SendEmailProviderProps> = ({ upstreamOptions, editType, multiNodeOptions, children }) => {
    const contextValue = React.useMemo(
        () => ({ upstreamOptions, editType, multiNodeOptions }),
        [multiNodeOptions, editType, upstreamOptions]
    )

    return <SendEmailContext.Provider value={contextValue}>{children}</SendEmailContext.Provider>
}

export const useSendEmailContext = () => useContext(SendEmailContext)

SendEmailContext.displayName = 'SendEmailContext'
